import { render, staticRenderFns } from "./ProspectEchangeCreate.vue?vue&type=template&id=4e3d46ee"
import script from "./ProspectEchangeCreate.vue?vue&type=script&lang=ts"
export * from "./ProspectEchangeCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports